// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uAtuoC664jgHUbjZFeob {
  display: flex;
  flex-direction: column;
}

.OwOKL5RRkvhm03LQReTw {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center
}

.vZwQafMsxub8ygBbVWkU {
  display: flex;
  width: 100%;
  flex-direction: row;
}

.SGVz91dGxsZVX84MkRCj {
  flex-direction: column;
  height: auto;
  margin: 3%;
  width: 100%;
  max-height: 600px;
  overflow: scroll;
  padding: 12px;
  border-radius: 20px;
  justify-content: space-around;
  align-items: center;
}

.NFWT9sS4vMe7XMQ3CtM9 {
  border-color: orange;
  border-weight: 3;
}

.AN0b4qm1gjHRbI5mzmpR {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5%;
  flex: 0;
}
.kqQ7JCi8BJOy_zCVgCoY {
  height: 50;
  border-radius: 15;
  text-align: center;
}
.v3J1_R1W3Z8vgmgqutZc {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  transition: all 1s ease 0.5s;
}

.q1JufnSAVf2U3LW61lUg {}
.UB2mog1Q656PdL8T7DJ5 {}

.E6yhuULmhwsgAjCLTbPN {
  display: flex;
  flex-direction: column;
  
}

.oh01JzEfBJcDGv5Ts1Sr {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 12px 0%;
}
.JLdp3F7IVlSRfyM0_R6g {
  width: 100%;
  height: auto;
  padding-left: 3%;
}
.wldYVkcScGn3iDNtZmMA {
  width: 89%;
  height: 4vh;
  font-size: 1.2em;
  border-radius: 15px;
  border: 2px inset;
  padding-left: 8%;
  outline-style: none;
}

.eblOcERnG_KyQCoa0jgl {
  width: 90%;
  display: flex;
  flex-direction: column;
  flex: 1;
}

touchable {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 26%;
}
.hgc6JIXduY3aARMcrVle {
  display: flex;
  bottom: 0;
  left: 0;
  height: 4vh;
  flex-direction: row;
  margin: 2vh 0%;
  width: 100%;
  align-items: center;
  justify-content: space-around;
}
.MuqJk53t3TjItdbVvyyZ {
  width: 33%;
  height: auto;
}
.fzUqHFaKrL99m1NBe3rN {
  align-items: center;
  justify-content: center;
  width: 80%;
  min-width: 50px;
  height: 100%;
  border-radius: 10px;
  padding: 2px 0px;
}
.vHsOviWI3h2DPlL5yotV {
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 100%;
  border-radius: 10px;
  elevation: 1;
}
.eZ56lf0lTKQZXnPnr1wP {
  width: auto;
  height: auto;
  padding: 5%;
  border-radius: 10px;
  box-shadow: 1px 1px 2px rgb(0, 0, 0, 0.8);
}
.LkhATIgwCe9k8MZGV8xo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: auto;
}
.oJ00y5xDnkfZ4pw5BR8E {
  align-items: center;
  justify-content: space-around;
}
.DvYhYZDLqqJ2d29U8prZ {
  display: flex;
  height: 100%;
  width: 100%;
}
.qPoc0T1HksEVdIuZCr3L {
  height: 100%;
  width: 100%;
}
.yw2dwMGu7z530TPDh4Km {
  max-width: 100%;
}
.cp82jLWDaeh7OtZ1wyue {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 33%;
}
`, "",{"version":3,"sources":["webpack://./src/Forms.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,OAAO;AACT;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,uBAAO;AACP,uBAAO;;AAEP;EACE,aAAa;EACb,sBAAsB;;AAExB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,SAAS;EACT,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ","sourcesContent":[".contentContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.flexCI {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center\n}\n\n.formContainer {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n}\n\n.inputsContainer {\n  flex-direction: column;\n  height: auto;\n  margin: 3%;\n  width: 100%;\n  max-height: 600px;\n  overflow: scroll;\n  padding: 12px;\n  border-radius: 20px;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.activeIcon {\n  border-color: orange;\n  border-weight: 3;\n}\n\n.titleContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 5%;\n  flex: 0;\n}\n.picker {\n  height: 50;\n  border-radius: 15;\n  text-align: center;\n}\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  overflow: hidden;\n  transition: all 1s ease 0.5s;\n}\n\n.date {}\n.time {}\n\n.summaryContainer {\n  display: flex;\n  flex-direction: column;\n  \n}\n\n.inputContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 12px 0%;\n}\n.inputLabel {\n  width: 100%;\n  height: auto;\n  padding-left: 3%;\n}\n.textInput {\n  width: 89%;\n  height: 4vh;\n  font-size: 1.2em;\n  border-radius: 15px;\n  border: 2px inset;\n  padding-left: 8%;\n  outline-style: none;\n}\n\n.reviewInfo {\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\ntouchable {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 26%;\n}\n.buttonsContainer {\n  display: flex;\n  bottom: 0;\n  left: 0;\n  height: 4vh;\n  flex-direction: row;\n  margin: 2vh 0%;\n  width: 100%;\n  align-items: center;\n  justify-content: space-around;\n}\n.labelContainer {\n  width: 33%;\n  height: auto;\n}\n.secButton {\n  align-items: center;\n  justify-content: center;\n  width: 80%;\n  min-width: 50px;\n  height: 100%;\n  border-radius: 10px;\n  padding: 2px 0px;\n}\n.mainButton {\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  border-radius: 10px;\n  elevation: 1;\n}\n.lonelyButton {\n  width: auto;\n  height: auto;\n  padding: 5%;\n  border-radius: 10px;\n  box-shadow: 1px 1px 2px rgb(0, 0, 0, 0.8);\n}\n.iconContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20%;\n  height: auto;\n}\n.flexItemCentered {\n  align-items: center;\n  justify-content: space-around;\n}\n.flatListContainer {\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n.listItemsContainer {\n  height: 100%;\n  width: 100%;\n}\n.listContainer {\n  max-width: 100%;\n}\n.touchable {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 33%;\n}\n"],"sourceRoot":""}]);
// Exports
export var contentContainer = `uAtuoC664jgHUbjZFeob`;
export var flexCI = `OwOKL5RRkvhm03LQReTw`;
export var formContainer = `vZwQafMsxub8ygBbVWkU`;
export var inputsContainer = `SGVz91dGxsZVX84MkRCj`;
export var activeIcon = `NFWT9sS4vMe7XMQ3CtM9`;
export var titleContainer = `AN0b4qm1gjHRbI5mzmpR`;
export var picker = `kqQ7JCi8BJOy_zCVgCoY`;
export var infoContainer = `v3J1_R1W3Z8vgmgqutZc`;
export var date = `q1JufnSAVf2U3LW61lUg`;
export var time = `UB2mog1Q656PdL8T7DJ5`;
export var summaryContainer = `E6yhuULmhwsgAjCLTbPN`;
export var inputContainer = `oh01JzEfBJcDGv5Ts1Sr`;
export var inputLabel = `JLdp3F7IVlSRfyM0_R6g`;
export var textInput = `wldYVkcScGn3iDNtZmMA`;
export var reviewInfo = `eblOcERnG_KyQCoa0jgl`;
export var buttonsContainer = `hgc6JIXduY3aARMcrVle`;
export var labelContainer = `MuqJk53t3TjItdbVvyyZ`;
export var secButton = `fzUqHFaKrL99m1NBe3rN`;
export var mainButton = `vHsOviWI3h2DPlL5yotV`;
export var lonelyButton = `eZ56lf0lTKQZXnPnr1wP`;
export var iconContainer = `LkhATIgwCe9k8MZGV8xo`;
export var flexItemCentered = `oJ00y5xDnkfZ4pw5BR8E`;
export var flatListContainer = `DvYhYZDLqqJ2d29U8prZ`;
export var listItemsContainer = `qPoc0T1HksEVdIuZCr3L`;
export var listContainer = `yw2dwMGu7z530TPDh4Km`;
export var touchable = `cp82jLWDaeh7OtZ1wyue`;
export default ___CSS_LOADER_EXPORT___;
